import VApp from './VApp';
export { VApp };
export default VApp;
//# sourceMappingURL=index.js.map